import { render, staticRenderFns } from "./WatchRecorded.vue?vue&type=template&id=72f50db4&scoped=true"
import script from "./WatchRecorded.vue?vue&type=script&lang=ts"
export * from "./WatchRecorded.vue?vue&type=script&lang=ts"
import style0 from "./WatchRecorded.vue?vue&type=style&index=0&id=72f50db4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f50db4",
  null
  
)

export default component.exports